import styled from 'styled-components';

import BadgeComponent from 'v3/components/Badge';

export const BadgeTag = styled(BadgeComponent)`
  padding: 5px 17px !important;
  background-color: #e3e4e7 !important;
  border-color: #e3e4e7 !important;
`;

export const Badge = styled(BadgeComponent)`
  padding: 5px 17px !important;
`;
